import React from 'react';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';

import LloydCart from "../models/LloydCart";
import DisabledFormBottom from "./DisabledFormBottom";
import SubmittingFormBottom from "./SubmittingFormBottom";
import EnabledFormBottom from "./EnabledFormBottom";

// Note that component is rendered as nothingness
// when cart is empty.

// Under the cart items; holds the add to cart button and maybe some kind of
// summary with totals and whatnot.
export default function LloydFormBottom({
  lloydCart, cartErrors, submitting, callbacks}) {

  const items = (lloydCart && lloydCart.items) ? lloydCart.items.toArray() : [];

  if (isEmpty(items)) return null;

  if (submitting) {
    return <SubmittingFormBottom callbacks={callbacks} lloydCart={lloydCart} />
  } else if (isEmpty(cartErrors)) {
    return <EnabledFormBottom callbacks={callbacks} lloydCart={lloydCart} />
  } else {
    return <DisabledFormBottom cartErrors={cartErrors}/>
  }
}

LloydFormBottom.propTypes = {
  lloydCart: PropTypes.instanceOf(LloydCart)
}
